// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSummaryStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';
import fetcher from 'fetchers/Izenda.RoleSetupFetcher';
import PermissionSummary from 'logic/models/Izenda.PermissionSummary';
import { isNil } from 'lodash/fp';
export default class PermissionSummaryStore {
  @observable tenantId;
  @observable model;

  constructor(tenantId: string, model: any) {
    this.tenantId = tenantId || null;
    this.model = model || new PermissionSummary();
  }

  /**
   * loadPermissionSummary
   * @param  {string} tenantId
   * @return {Promise}
   */
  @action
  loadPermissionSummary(tenantId: string): any {
    tenantId = tenantId || this.tenantId;
    const readPermissionSummay = action(function(result) {
      if (isNil(result.message)) {
        this.model.populateData(result);
      }
    });
    return fetcher
      .loadPermissionSummary(tenantId)
      .bind(this)
      .then(readPermissionSummay);
  }
}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.PermissionSummaryStore.js